/**
 * Content-Design-authored copy for the /renewal/not-permitted route
 * (TG-43, Content Design Agent mandatory per the constitution's trigger
 * table for user-facing text).
 *
 * Generalised, ADR-20261016-b9hz: this feature's own TG-6 now reaches this
 * view for every refusal AC-19 names, not only a rejected submission --
 * a contributor deep-linking screen 3 or screen 6 (ADR-20261015-c9zb) and a
 * contributor refused a section or endpoint outside their delegated set all
 * land here too. The original copy ("Only the renewal's owner can submit")
 * was submission-specific and read as untrue for those other cases, so it
 * is replaced with wording that holds for all of them: it names no action
 * the viewer tried (submit, open a section, reach a screen), states only
 * that they do not have access, and offers the identical single action
 * (returning to the renewal, where their own saved or delegated-section
 * answers remain readable) regardless of which refusal brought them here.
 * No submission or other action is ever recorded when this view is shown
 * -- the single action is framed as a return, never a retry of anything.
 * `helpLine` is the AC-29 help line, shown since the ADR-20261008-hsvr
 * amendment of 2026-10-11.
 */
export const notPermittedContent = {
  heading: "You don't have access to this",
  body: "You can keep working on the sections assigned to you until this is resolved.",
  returnToRenewalActionLabel: "Return to your renewal",
  helpLine: "Need help? Contact your Account Manager.",
} as const;
